
<template>

<!-- noch keine weitere anpassungen in den anderen Dateien vorgenommen index routes usw -->
<!-- <body class="my-login-page"> -->
	<section class="h-100">
		
			<div class="row justify-content-md-center h-100">
				<div class="card-wrapper">
					<div class="brand">
						<!-- <img src="..\assets\logo.jpg"> -->
					</div>
					<div class="card fat">
						<div class="card-body">
							<h4 class="card-title">Login</h4>
							<br>
							<form action="index.html">
							 
								<div class="form-group">
									<label for="email">E-Mail address:</label>

									<input id="email" type="email" class="form-control" name="email" v-model="email" value="" required autofocus>
								</div>

								<div class="form-group">
									<label for="password">Password:
										<!-- <a href="" class="float-right">
											forgot password?
										</a> -->
									</label>
									<input id="password" type="password" class="form-control" name="password" v-model="password" required data-eye>
								</div>

								<div class="form-group">
									<label>
										<input type="checkbox" name="remember"> Remember Me
									</label>
								</div>

								<div class="form-group no-margin">
									<button v-on:click="login" class="btn btn-danger btn-block">
										Login
									</button>
								</div>
								<div class="margin-top20 text-center">
									Don't have an account? <a href="mailto:info@katsios-kesting.de">Mail to info@katsios-kesting.de</a>
								</div>
							</form>
						</div>
					</div>
					<!-- <div class="footer"><center>
						&mdash; Copyright &copy; 2018 &mdash;
					</center></div> -->
				</div>
			</div>
		
	</section>

	<!-- </body> -->

</template>

<script>

import firebase from 'firebase';

export default {
  name: 'login',
  data: function() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
      login: function(e){		  
          firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(user => {    
			  			this.$router.go({path: this.$router.path});  
          },
          err => {
              alert(err.message);
          });
          e.preventDefault();
      }
  }
};
</script>
